import { useEffect, useState } from "react";
import Carousel from "../components/home/Carousel";
import {
  ICountData,
  IMemberListData,
  //   IMemberData,
  IMemberWorldData,
  ISliderData,
//   ITestimonyData,
//   ITestimonyTitleData,
  ITilesData,
  IWelcomeData,
} from "../exports/interfaces";
import {
  fetchCountData,
  fetchHomeSliders,
  fetchMemberWorldData,
//   fetchTestimonyData,
//   fetchTestimonyTitleData,
  fetchTilesData,
  fetchWelcomeData,
} from "../api/HomeApi";
import { dynamicFailed } from "../hooks/useToast";
import Tiles from "../components/home/Tiles";
import Welcome from "../components/home/Welcome";
import TopEvents from "../components/home/TopEvents";
import { useEventContext } from "../context/EventContext";
import { fetchEventBanner, fetchEventData } from "../api/EventApi";
import BenefitsOfMember from "../components/home/BenefitsOfMember";
import MembersWorld from "../components/home/MembersWorld";
import { useLoader } from "../context/LoaderContext";
import { useEventBannerContext } from "../context/EventBannerContext";
// import Testimony from "../components/home/Testimony";
import { fetchMemberLists } from "../api/MemberApi"; 
import { scroller } from "react-scroll";

const Home = () => {
  const { setEventData } = useEventContext();
  const { setEventBannerData } = useEventBannerContext();
  const { setLoading } = useLoader();
  const [memberCount, setMemberCount] = useState<number>(0);
  const [countryCount, setCountryCount] = useState<number>(0);
  const [sliderData, setSliderData] = useState<ISliderData[]>([]);
  const [welcomeData, setWelcomeData] = useState<IWelcomeData[]>([]);
  const [tilesData, setTilesData] = useState<ITilesData[]>([]);
  const [countData, setCountData] = useState<ICountData[]>([]);
  const [memberWorldData, setMemberWorldData] = useState<IMemberWorldData[]>(
    []
  );
//   const [testimonyTitleData, setTestimonyTitleData] = useState<
//     ITestimonyTitleData[]
//   >([]);
//   const [testimonyData, setTestimonyData] = useState<ITestimonyData[]>([]);
  useEffect(() => {
    scroller.scrollTo("toTop", {
      duration: 500,
      smooth: true,
    });
  }, []);
  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchHomeSliders(),
      fetchTilesData(),
      fetchWelcomeData(),
      fetchCountData(),
      fetchMemberWorldData(),
    //   fetchTestimonyTitleData(),
    //   fetchTestimonyData(),
      fetchMemberLists(),
    ])
      .then(
        ([
          homeSliderData,
          homeTilesData,
          homeWelcomeData,
          countData,
          memberWorldData,
        //   testimonyTitleData,
        //   testimonyData,
          listMemberData,
        ]) => {
          setSliderData(homeSliderData);
          setTilesData(homeTilesData);
          setWelcomeData(homeWelcomeData);
          setCountData(countData);
          setMemberWorldData(memberWorldData);
        //   setTestimonyTitleData(testimonyTitleData);
        //   setTestimonyData(testimonyData);
          const activeMembers = listMemberData.filter(
            (member: IMemberListData) =>
              member.attributes?.Status === "Active"
          );

          setMemberCount(activeMembers.length);

          const countries = activeMembers.map((member: IMemberListData) =>
            member.attributes?.Country?.trim()
          );
          const uniqueCountries = new Set(countries.filter(Boolean));
          setCountryCount(uniqueCountries.size);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      )
      .catch(() => {
        dynamicFailed("Server Error");
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);
  useEffect(() => {
    Promise.all([fetchEventData(), fetchEventBanner()])
      .then(([eventData, eventBannerData]) => {
        setEventData(eventData);
        setEventBannerData(eventBannerData);
      })
      .catch(() => {
        dynamicFailed("Server Error");
      });
  }, [setEventBannerData, setEventData]);

  return (
    <>
      {/* 
        <div className="stricky-header stricked-menu main-menu main-menu-two stricky-fixed">
            <div className="sticky-header__content"></div> 
        </div>  */}
      <Carousel sliderData={sliderData} />
      <Tiles tilesData={tilesData} />
      <Welcome welcomeData={welcomeData} />
      <TopEvents />
      {/* <Testimony
        testimonyTitleData={testimonyTitleData}
        testimonyData={testimonyData}
      /> */}
      <BenefitsOfMember
        countData={countData}
        memberCount={memberCount}
        countryCount={countryCount}
      />
      <MembersWorld memberWorldData={memberWorldData} />

      {/* <section className="fundraishing">
            <div className="fundraishing-bg-box">
                <div className="fundraishing-bg jarallax" data-jarallax data-speed="0.2" data-imgPosition="50% 0%"
                    style={{backgroundImage: 'url(assets/images/backgrounds/fundraishing-bg.jpg)'}}></div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="fundraishing__inner">
                            <p className="fundraishing__sub-title">We’re Here to Support Them</p>
                            <h2 className="fundraishing__title">Fundraising for the <span>People</span> and <br /> Causes you
                                Care About</h2>
                            <div className="fundraishing__btn-box">
                                <a href="donate-now.html" className="thm-btn fundraishing__btn">Start Donating now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         

         
        <section className="causes-one causes-two">
            <div className="container">
                <div className="section-title text-left">
                    <span>Help the people</span>
                    <h2 className="section-title__title">Popular Causes</h2>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="causes-one__carousel owl-theme owl-carousel">
                             
                            <div className="causes-one__single">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-1.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>education</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="give-them-education.html">Give African Child a Good Education</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress causes-one__progress-2">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-2">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-2.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>medical</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="start-a-fundraising.html">A Little Help can Heal their Pains</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-3">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-3.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>Food</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="clean-pure-water.html">Raise Fund for Clean & Healthy Food</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-1.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>education</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="give-them-education.html">Give African Child a Good Education</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress causes-one__progress-2">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-2">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-2.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>medical</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="start-a-fundraising.html">A Little Help can Heal their Pains</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-3">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-3.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>Food</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="clean-pure-water.html">Raise Fund for Clean & Healthy Food</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-1.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>education</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="give-them-education.html">Give African Child a Good Education</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress causes-one__progress-2">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-2">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-2.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>medical</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="start-a-fundraising.html">A Little Help can Heal their Pains</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-3">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-3.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>Food</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="clean-pure-water.html">Raise Fund for Clean & Healthy Food</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-1.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>education</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="give-them-education.html">Give African Child a Good Education</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress causes-one__progress-2">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-2">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-2.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>medical</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="start-a-fundraising.html">A Little Help can Heal their Pains</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             
                            <div className="causes-one__single causes-one__single-3">
                                <div className="causes-one__img">
                                    <img src="assets/images/causes/causes-1-3.jpg" alt="" />
                                    <div className="causes-one__category">
                                        <span>Food</span>
                                    </div>
                                </div>
                                <div className="causes-one__content-box">
                                    <div className="causes-one__content">
                                        <h3 className="causes-one__title">
                                            <a href="clean-pure-water.html">Raise Fund for Clean & Healthy Food</a>
                                        </h3>
                                        <p className="causes-one__text">Aellentesque porttitor lacus quis enim varius sed
                                            efficitur...</p>
                                    </div>
                                    <div className="causes-one__progress">
                                        <div className="bar">
                                            <div className="bar-inner count-bar" data-percent="36%">
                                                <div className="count-text">36%</div>
                                            </div>
                                        </div>
                                        <div className="causes-one__goals">
                                            <p><span>$25,270</span> Raised</p>
                                            <p><span>$30,000</span> Goal</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         

         
        <section className="gallery-one">
            <div className="gallery-one__container">
                <ul className="gallery-one__content list-unstyled">
                    <li className="gallery-one__single wow fadeInUp" data-wow-delay="100ms">
                        <div className="gallery-one__img-box">
                            <div className="gallery-one__img-inner">
                                <img src="assets/images/gallery/gallery-1-1.jpg" alt="" />
                            </div>
                            <div className="gallery-one__img-overly">
                                <div className="gallery-one__icon-bg">
                                    <img src="assets/images/shapes/gallery-shape.png" alt="" />
                                </div>
                                <a className="img-popup" href="assets/images/gallery/gallery-1-1.jpg">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </li>
                    <li className="gallery-one__single wow fadeInUp" data-wow-delay="200ms">
                        <div className="gallery-one__img-box">
                            <div className="gallery-one__img-inner">
                                <img src="assets/images/gallery/gallery-1-2.jpg" alt="" />
                            </div>
                            <div className="gallery-one__img-overly">
                                <div className="gallery-one__icon-bg">
                                    <img src="assets/images/shapes/gallery-shape.png" alt="" />
                                </div>
                                <a className="img-popup" href="assets/images/gallery/gallery-1-2.jpg">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </li>
                    <li className="gallery-one__single wow fadeInUp" data-wow-delay="300ms">
                        <div className="gallery-one__img-box">
                            <div className="gallery-one__img-inner">
                                <img src="assets/images/gallery/gallery-1-3.jpg" alt="" />
                            </div>
                            <div className="gallery-one__img-overly">
                                <div className="gallery-one__icon-bg">
                                    <img src="assets/images/shapes/gallery-shape.png" alt="" />
                                </div>
                                <a className="img-popup" href="assets/images/gallery/gallery-1-3.jpg">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </li>
                    <li className="gallery-one__single wow fadeInUp" data-wow-delay="400ms">
                        <div className="gallery-one__img-box">
                            <div className="gallery-one__img-inner">
                                <img src="assets/images/gallery/gallery-1-4.jpg" alt="" />
                            </div>
                            <div className="gallery-one__img-overly">
                                <div className="gallery-one__icon-bg">
                                    <img src="assets/images/shapes/gallery-shape.png" alt="" />
                                </div>
                                <a className="img-popup" href="assets/images/gallery/gallery-1-4.jpg">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </li>
                    <li className="gallery-one__single wow fadeInUp" data-wow-delay="500ms">
                        <div className="gallery-one__img-box">
                            <div className="gallery-one__img-inner">
                                <img src="assets/images/gallery/gallery-1-5.jpg" alt="" />
                            </div>
                            <div className="gallery-one__img-overly">
                                <div className="gallery-one__icon-bg">
                                    <img src="assets/images/shapes/gallery-shape.png" alt="" />
                                </div>
                                <a className="img-popup" href="assets/images/gallery/gallery-1-5.jpg">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
         

         
        <section className="testimonial-two">
            <div className="testimonial-two-bg"
                style={{backgroundImage: 'url(assets/images/backgrounds/testimonial-two-bg.png)'}}></div>
            <div className="container">
                <div className="row">
                    <div className="col-xl-4">
                        <div className="testimonial-two__left">
                            <div className="section-title text-left">
                                <span>our testimonials</span>
                                <h2 className="section-title__title">What They’re Talking About Company?</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8">
                        <div className="testimonial-two__right">
                            <div className="testimonial-two__carousel owl-carousel owl-theme">
                                 
                                <div className="testimonial-two__single">
                                    <div className="testimonial-two__content">
                                        <div className="testimonial-two__quote">
                                            <span className="icon-quote"></span>
                                        </div>
                                        <p className="testimonial-two__text">Lorem ipsum is simply free text dolor sit amet,
                                            consect notted adipisicing elit sed do eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua.</p>
                                    </div>
                                    <div className="testimonial-two__client-info">
                                        <div className="testimonial-two__client-img">
                                            <img src="assets/images/testimonial/testimonials-2-1.jpg" alt="" />
                                        </div>
                                        <div className="testimonial-two__client-details">
                                            <h5 className="testimonial-two__client-name">Kevin Martin</h5>
                                            <p className="testimonial-two__client-title">Customer</p>
                                        </div>
                                    </div>
                                </div>
                                 
                                <div className="testimonial-two__single">
                                    <div className="testimonial-two__content">
                                        <div className="testimonial-two__quote">
                                            <span className="icon-quote"></span>
                                        </div>
                                        <p className="testimonial-two__text">Lorem ipsum is simply free text dolor sit amet,
                                            consect notted adipisicing elit sed do eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua.</p>
                                    </div>
                                    <div className="testimonial-two__client-info">
                                        <div className="testimonial-two__client-img">
                                            <img src="assets/images/testimonial/testimonials-2-2.jpg" alt="" />
                                        </div>
                                        <div className="testimonial-two__client-details">
                                            <h5 className="testimonial-two__client-name">Sarah Albert</h5>
                                            <p className="testimonial-two__client-title">Customer</p>
                                        </div>
                                    </div>
                                </div>
                                 
                                <div className="testimonial-two__single">
                                    <div className="testimonial-two__content">
                                        <div className="testimonial-two__quote">
                                            <span className="icon-quote"></span>
                                        </div>
                                        <p className="testimonial-two__text">Lorem ipsum is simply free text dolor sit amet,
                                            consect notted adipisicing elit sed do eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua.</p>
                                    </div>
                                    <div className="testimonial-two__client-info">
                                        <div className="testimonial-two__client-img">
                                            <img src="assets/images/testimonial/testimonials-2-1.jpg" alt="" />
                                        </div>
                                        <div className="testimonial-two__client-details">
                                            <h5 className="testimonial-two__client-name">Kevin Martin</h5>
                                            <p className="testimonial-two__client-title">Customer</p>
                                        </div>
                                    </div>
                                </div>
                                 
                                <div className="testimonial-two__single">
                                    <div className="testimonial-two__content">
                                        <div className="testimonial-two__quote">
                                            <span className="icon-quote"></span>
                                        </div>
                                        <p className="testimonial-two__text">Lorem ipsum is simply free text dolor sit amet,
                                            consect notted adipisicing elit sed do eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua.</p>
                                    </div>
                                    <div className="testimonial-two__client-info">
                                        <div className="testimonial-two__client-img">
                                            <img src="assets/images/testimonial/testimonials-2-2.jpg" alt="" />
                                        </div>
                                        <div className="testimonial-two__client-details">
                                            <h5 className="testimonial-two__client-name">Sarah Albert</h5>
                                            <p className="testimonial-two__client-title">Customer</p>
                                        </div>
                                    </div>
                                </div>
                                 
                                <div className="testimonial-two__single">
                                    <div className="testimonial-two__content">
                                        <div className="testimonial-two__quote">
                                            <span className="icon-quote"></span>
                                        </div>
                                        <p className="testimonial-two__text">Lorem ipsum is simply free text dolor sit amet,
                                            consect notted adipisicing elit sed do eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua.</p>
                                    </div>
                                    <div className="testimonial-two__client-info">
                                        <div className="testimonial-two__client-img">
                                            <img src="assets/images/testimonial/testimonials-2-1.jpg" alt="" />
                                        </div>
                                        <div className="testimonial-two__client-details">
                                            <h5 className="testimonial-two__client-name">Kevin Martin</h5>
                                            <p className="testimonial-two__client-title">Customer</p>
                                        </div>
                                    </div>
                                </div>
                                 
                                <div className="testimonial-two__single">
                                    <div className="testimonial-two__content">
                                        <div className="testimonial-two__quote">
                                            <span className="icon-quote"></span>
                                        </div>
                                        <p className="testimonial-two__text">Lorem ipsum is simply free text dolor sit amet,
                                            consect notted adipisicing elit sed do eiusmod tempor incididunt ut labore
                                            et dolore magna aliqua.</p>
                                    </div>
                                    <div className="testimonial-two__client-info">
                                        <div className="testimonial-two__client-img">
                                            <img src="assets/images/testimonial/testimonials-2-2.jpg" alt="" />
                                        </div>
                                        <div className="testimonial-two__client-details">
                                            <h5 className="testimonial-two__client-name">Sarah Albert</h5>
                                            <p className="testimonial-two__client-title">Customer</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         

         
        <section className="volunteers-one">
            <div className="volunteers-one-shape"
                style={{backgroundImage: 'url(assets/images/shapes/volunteers-one-shape.png)'}}></div>
            <div className="container">
                <div className="section-title text-center">
                    <span>Ready to help you</span>
                    <h2 className="section-title__title">Happy Volunteers</h2>
                </div>
                <div className="row">
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
                         
                        <div className="volunteers-one__single">
                            <div className="volunteers-one__img">
                                <img src="assets/images/team/volunteers-1-1.jpg" alt="" />
                                <div className="volunteers-one__social">
                                    <a href="#"><i className="fab fa-twitter"></i></a>
                                    <a href="#"><i className="fab fa-facebook"></i></a>
                                    <a href="#"><i className="fab fa-pinterest-p"></i></a>
                                    <a href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="volunteers-one__content">
                                <h4 className="volunteers-one__name">Sarah Albert</h4>
                                <p className="volunteers-one__title">Volunteers</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="200ms">
                         
                        <div className="volunteers-one__single">
                            <div className="volunteers-one__img">
                                <img src="assets/images/team/volunteers-1-2.jpg" alt="" />
                                <div className="volunteers-one__social">
                                    <a href="#"><i className="fab fa-twitter"></i></a>
                                    <a href="#"><i className="fab fa-facebook"></i></a>
                                    <a href="#"><i className="fab fa-pinterest-p"></i></a>
                                    <a href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="volunteers-one__content">
                                <h4 className="volunteers-one__name">Kevin Martin</h4>
                                <p className="volunteers-one__title">Volunteers</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="300ms">
                         
                        <div className="volunteers-one__single">
                            <div className="volunteers-one__img">
                                <img src="assets/images/team/volunteers-1-3.jpg" alt="" />
                                <div className="volunteers-one__social">
                                    <a href="#"><i className="fab fa-twitter"></i></a>
                                    <a href="#"><i className="fab fa-facebook"></i></a>
                                    <a href="#"><i className="fab fa-pinterest-p"></i></a>
                                    <a href="#"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                            <div className="volunteers-one__content">
                                <h4 className="volunteers-one__name">Jeesica Brown</h4>
                                <p className="volunteers-one__title">Volunteers</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
         

         
        <section className="brand-two">
            <div className="container">
                <div className="brand-two__inner">
                    <div className="thm-swiper__slider swiper-container" data-swiper-options='{"spaceBetween": 100, "slidesPerView": 5, "autoplay": { "delay": 5000 }, "breakpoints": {
                        "0": {
                            "spaceBetween": 30,
                            "slidesPerView": 2
                        },
                        "375": {
                            "spaceBetween": 30,
                            "slidesPerView": 2
                        },
                        "575": {
                            "spaceBetween": 30,
                            "slidesPerView": 3
                        },
                        "767": {
                            "spaceBetween": 50,
                            "slidesPerView": 4
                        },
                        "991": {
                            "spaceBetween": 50,
                            "slidesPerView": 5
                        },
                        "1199": {
                            "spaceBetween": 100,
                            "slidesPerView": 5
                        }
                    }}'>
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-1.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-2.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-3.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-4.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-5.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-1.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-2.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-3.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-4.png" alt="" />
                            </div> 
                            <div className="swiper-slide">
                                <img src="assets/images/brand/brand-2-5.png" alt="" />
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        </section>
         

         
        <section className="blog-one blog-two">
            <div className="container">
                <div className="section-title text-center">
                    <span>From the Blog</span>
                    <h2 className="section-title__title">News & Articles</h2>
                </div>
                <div className="row">
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms">
                         
                        <div className="blog-one__single">
                            <div className="blog-one__img">
                                <img src="assets/images/blog/blog-1-1.jpg" alt="" />
                                <div className="blog-one__date">
                                    <p>26 oct</p>
                                </div>
                                <a href="blog-details.html">
                                    <span className="news-one__plus"></span>
                                </a>
                            </div>
                            <div className="blog-one__content">
                                <ul className="list-unstyled blog-one__meta">
                                    <li><a href="blog-details.html"><i className="far fa-user-circle"></i> Admin</a></li>
                                    <li><a href="blog-details.html"><i className="far fa-comments"></i> 2 Comments</a>
                                    </li>
                                </ul>
                                <h3 className="blog-one__title">
                                    <a href="blog-details.html">Start a Fundraiser for
                                        Yourself</a>
                                </h3>
                                <p className="blog-one__text">Aellentesque porttitor lacus quis enim varius sed efficitur...
                                </p>
                                <div className="blog-one__bottom">
                                    <a href="blog-details.html" className="blog-one__btn">Read More</a>
                                    <a href="blog-details.html" className="blog-one__arrow"><span
                                            className="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="200ms">
                         
                        <div className="blog-one__single">
                            <div className="blog-one__img">
                                <img src="assets/images/blog/blog-1-2.jpg" alt="" />
                                <div className="blog-one__date">
                                    <p>26 oct</p>
                                </div>
                                <a href="blog-details.html">
                                    <span className="news-one__plus"></span>
                                </a>
                            </div>
                            <div className="blog-one__content">
                                <ul className="list-unstyled blog-one__meta">
                                    <li><a href="blog-details.html"><i className="far fa-user-circle"></i> Admin</a></li>
                                    <li><a href="blog-details.html"><i className="far fa-comments"></i> 2 Comments</a>
                                    </li>
                                </ul>
                                <h3 className="blog-one__title">
                                    <a href="blog-details.html">School Counseling for Children</a>
                                </h3>
                                <p className="blog-one__text">Aellentesque porttitor lacus quis enim varius sed efficitur...
                                </p>
                                <div className="blog-one__bottom">
                                    <a href="blog-details.html" className="blog-one__btn">Read More</a>
                                    <a href="blog-details.html" className="blog-one__arrow"><span
                                            className="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="300ms">
                         
                        <div className="blog-one__single">
                            <div className="blog-one__img">
                                <img src="assets/images/blog/blog-1-3.jpg" alt="" />
                                <div className="blog-one__date">
                                    <p>26 oct</p>
                                </div>
                                <a href="blog-details.html">
                                    <span className="news-one__plus"></span>
                                </a>
                            </div>
                            <div className="blog-one__content">
                                <ul className="list-unstyled blog-one__meta">
                                    <li><a href="blog-details.html"><i className="far fa-user-circle"></i> Admin</a></li>
                                    <li><a href="blog-details.html"><i className="far fa-comments"></i> 2 Comments</a>
                                    </li>
                                </ul>
                                <h3 className="blog-one__title">
                                    <a href="blog-details.html">Growing Up children in Charity Care</a>
                                </h3>
                                <p className="blog-one__text">Aellentesque porttitor lacus quis enim varius sed efficitur...
                                </p>
                                <div className="blog-one__bottom">
                                    <a href="blog-details.html" className="blog-one__btn">Read More</a>
                                    <a href="blog-details.html" className="blog-one__arrow"><span
                                            className="icon-right-arrow"></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section> */}
    </>
  );
};

export default Home;
